import React, { memo } from 'react';

function PieceTray({ pieces, selectedPiece, onPiecePointerDown, disabled }) {
  return (
    <div className="piece-tray" aria-label="Available pieces">
      {pieces.map((piece, index) => (
        <div
          key={piece.id}
          className={`tray-piece${selectedPiece === index ? ' tray-piece-selected' : ''}${disabled ? ' tray-piece-disabled' : ''}`}
          onPointerDown={(e) => !disabled && onPiecePointerDown(e, index)}
          role="button"
          tabIndex={disabled ? -1 : 0}
          aria-label={`Piece ${index + 1}: ${describePiece(piece)}`}
          aria-pressed={selectedPiece === index}
          onKeyDown={(e) => {
            if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
              e.preventDefault();
              onPiecePointerDown(e, index);
            }
          }}
        >
          <div className="piece-grid">
            {piece.shape.map((row, r) => (
              <div key={r} className="piece-row">
                {row.map((cell, c) => (
                  <div
                    key={c}
                    className={`piece-cell${cell ? ' piece-cell-filled' : ''}`}
                    style={cell ? { backgroundColor: piece.color, '--cell-color': piece.color } : {}}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function describePiece(piece) {
  const rows = piece.shape.length;
  const cols = piece.shape[0].length;
  let blocks = 0;
  for (const row of piece.shape) {
    for (const cell of row) {
      if (cell) blocks++;
    }
  }
  return `${blocks} block${blocks > 1 ? 's' : ''}, ${rows} by ${cols}`;
}

export default memo(PieceTray);
